import logoVAF from '../../../assets/logo-abogados-vaf.jpeg';
import logoAH from '../../../assets/logo-abogados-ah.png';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { templateData } from './../case-data';
import { Link, useParams } from 'react-router-dom';
import { getCase, updateCase } from './../../../actions/case-actions';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { getDocumentData } from '../../../actions/documents-actions';

function AuthorityTemplate(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [loadData, setLoadData] = useState(true);
    const [needUpdate, setNeedUpdate] = useState(false);
    const params = useParams();
    const user = useSelector(state => state.user.user);
    const [currentData, setCurrentData] = useState({});

    const [form, setForm] = useState({
        _id: '',
        authority: {
            generated: false,
            generationDate: new Date()
        },
    })

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    console.log(data.data);
                    data.data.currentProvince = data.data.client.clientId.province?data.data.client.clientId.province:data.data.province; 
                    data.data.currentCity = data.data.client.clientId.city?data.data.client.clientId.city:data.data.city; 
                    let clientName = `${data.data.client.clientId.firstName} ${data.data.client.clientId.lastName} ${data.data.client.clientId.documentType} ${data.data.client.clientId.document}`;
                    if (!data.data.client.clientId.city) {
                        Swal.fire({
                            title:"¡Advertencia!",
                            confirmButtonColor:"#76b4ff",
                            text: `El cliente "${clientName}" no posee una ciudad de residencia asociada, si desea que el documento se genere correctamente por favor diligencie dicha información, actualmente el documento usa la ciudad del caso`
                        });
                    }
                    setCurrentData( data.data );
                    
                    setForm({
                        ...form,
                        _id: data.data._id
                    })
                }
            }

            setLoadData(false);
            setForm({
                _id: '',
                authority: {
                    generated: false,
                    generationDate: new Date()
                },
            });
            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, user.token ]);

    const downloadFile = () => {
        if (!currentData.authority.generated) {
            setForm({
                ...form,
                authority: {
                    generated: true,
                    generationDate: new Date()
                }
            })
            setNeedUpdate(true);
        }
        let doc = new jsPDF('p', 'pt', 'a4');
        const element = document.querySelector("#capture");
        const marginX = 20;
        const opt = {
            margin: [38, marginX, 23, marginX],
            filename: `4 PODER ${currentData.client.clientId.lastName.toUpperCase()} EXP ${currentData.filingNumber}.pdf`,
            enableLinks: false,
            pagebreak: {
              avoid: ['tr'],
              mode: ['css', 'avoid-all'],
            },
            image: { type: 'jpeg', quality: 0.7 },
            html2canvas: {
              allowTaint: true,
              dpi: 300,
              letterRendering: true,
              logging: false,
              scale: 2,
              scrollX: 0,
              scrollY: 0,
            },
            jsPDF: { doc },
          };

        html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get('pdf')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i < totalPages + 1; i++) {
                pdf.setPage(i);
                pdf.setFontSize(7);

                let heightSpace = pdf.internal.pageSize.getHeight() - 12;
                let logo = currentData.legalCompany === 'VAF'? logoVAF:logoAH;
                const sizeX = currentData.legalCompany === 'VAF'? 38:33;
                const sizeY = currentData.legalCompany === 'VAF'? 20:23;
                let posX = pdf.internal.pageSize.getWidth()-(marginX+sizeX);
                // Validación de espacio porque el logo tiene márgenes
                posX = currentData.legalCompany === 'VAF'?(posX+4):posX;
                const posY = 10;

                // addImage(img, posX, posY, sizeX, sizeY) => posX = marginX+sizeX
                pdf.addImage(logo, posX, posY, sizeX, sizeY);

                Object.keys(templateData.company).map((keyName, i) => {
                    pdf.text(
                        `${templateData.company[keyName]}`,
                        (pdf.internal.pageSize.getWidth()/2)-(templateData.company[keyName].length/2),
                        heightSpace,
                    );
                    heightSpace += 3;
                    return i;
                })
                const pages = `${i}/${totalPages}`;
                pdf.text(
                    pages,
                    (pdf.internal.pageSize.getWidth()/2)-(pages.length/2),
                    heightSpace,
                );
            }
        })
        .save();
    }

    useEffect(() => {
        const updateFunction = (data) => {
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //navigate(currentLink)
                console.log(data);
                /*
                Swal.fire({
                    title:"¡Éxito!",
                    confirmButtonColor:"#76b4ff",
                    text: "Caso creado con éxito"
                });*/
            }
        }

        if (needUpdate) {
            dispatch( updateCase( form, updateFunction, user.token ) );
            setNeedUpdate(false);
            setLoadData(true);
        }
        //console.log(form)
    }, [needUpdate, dispatch, form, user.token]);

    return (
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink + `/editar/${params.id}`} key={params.id} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Poder</h1>
                <div className="d-flex flex-column p-4 template-container document-container">
                    <img src={currentData.legalCompany === 'VAF'? logoVAF:logoAH} alt="Logo" className="lawer-logo" />
                    { currentData._id ? 
                        getDocumentData('authority', currentData)
                    : ''}
                    <div className="d-flex justify-content-center w-100 info-span-container">
                        <div className="d-flex flex-column">
                            {Object.keys(templateData.company).map((keyName, i) => (
                                <span key={i} className="info-span">{templateData.company[keyName]}</span>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center w-100 my-2">
                    <button onClick={downloadFile} className="btn btn-primary">Descargar</button>
                </div>
            </div>
        </div>
    );
}
 
export default AuthorityTemplate;